// External deps
import { useContext } from 'react';

// Internal deps
import { CalendarContext } from '../context/CalendarProvider';

export default function useCalendar() {
  return useContext(CalendarContext);
}
